import React, { useState } from "react"

import ArrowRight from "@svg/ui/arrow-right-skinny.svg"
import { Link } from "gatsby"
import { CSSTransition } from "react-transition-group"

export const ButtonSolid = ({ link, children, className = "", external = false, func = null }) => {
  const [isHovered, setIsHovered] = useState(false)

  const clickHandler = () => {
    if (func == null) {
      return
    }
    func()
  }

  const buttonContent = (
    <div className="flex gap-4 flex-nowrap">
      {children}
      <CSSTransition in={isHovered} timeout={300} classNames="button-arrow">
        <div className="flex items-center fill-current">
          <ArrowRight />
        </div>
      </CSSTransition>
    </div>
  )

  if (external) {
    return (
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className={`${className} text-16 border transition-colors duration-300 flex items-center py-4 px-6 font-semi`}
        style={{ borderRadius: "30px" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {buttonContent}
      </a>
    )
  }

  if (link) {
    return (
      <Link
        to={link}
        className={`${className} text-16 border transition-colors duration-300 flex items-center py-4 px-6 font-semi`}
        style={{ borderRadius: "30px" }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {buttonContent}
      </Link>
    )
  }

  return (
    <button
      onClick={() => clickHandler()}
      className={`${className} text-16 border transition-colors duration-300 flex items-center py-4 px-6 font-semi`}
      style={{ borderRadius: "30px" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {buttonContent}
    </button>
  )
}
